/**
 * @file multipart/form-data で submit する
 */

'use strict'

import Form from "../../Controller/Form"
import Common from "../../Utils/Common"

/**
 * @classname SubmitMultipartFormData
 * @classdesc multipart/form-data で submit する
 */
export default class SubmitMultipartFormData {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('[data-form][data-multipart-form-data]')
	 * @param {Form} controller
	 */
	constructor($e, controller) {
		console.log(`SubmitMultipartFormData.constructor`)
		this._$e = $e
		this._controller = controller
		this._confirmationModalId = this._$e.closest('.modal').attr('id') ?? null
		this._$form = $(this._$e.data('form'))
		this._$e.on('click', () => this.onClick())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof SubmitMultipartFormData
	 * @return {undefined}
	 */
	onClick() {
		if(this._$e.hasClass('clicked')) return; // 複数クリック回避
		console.log(`SubmitMultipartFormData.onClick`)
		// clicked class付与
		this._$e.addClass('clicked')
		this._controller._listener.trigger('validate')
		const validity = !$('.is-invalid').not('.ignore-validate').length
		console.log(`validation completed: ${validity ? 'valid' : 'invalid'}`)
		if (validity) {
			const formData = new FormData(document.getElementById(this._$form.attr('id')))
			console.log('=== ▼ formData ▼ ===')
			for (let data of formData.entries()) {
				console.log(`${data[0]}: ${data[1]}`);
			}
			console.log('=== ▲ formData ▲ ===')
		this._controller.submitMultipartFormData(this._$form, formData, this._confirmationModalId)
		} else {
			Common.showErrorModal('項目に誤りがあります。')
			// clicked classの削除
			$('button[data-multipart-form-data]').removeClass('clicked')
		}
	}
}
